/**
 * assetsのパスを取得
 * 対象要素に以下のような設定がされている想定
 * data-assets-base="<?= esc_url(get_stylesheet_directory_uri() . '/assets'); ?>"
 */
export const getAssetsPath = (): string | null => {
  const target = document.getElementById('wrapper') as HTMLDivElement;
  if (!target) return null;

  const assetsPath = target.getAttribute('data-assets-base') as string;
  return assetsPath;
}